export default __webpack_public_path__ + "static/media/testimonial-landingpages-frame.3ca14a53.jpg";